import React from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { formatWalletAmount } from "./payouts-mock-data";
import { PayoutHistoryList } from "./payout-history-list";

const HEAD = [
  { id: "date", label: "DATE" },
  { id: "ref", label: "REFERENCE" },
  { id: "amount", label: "AMOUNT", align: "right" },
  { id: "method", label: "METHOD" },
];

export function PayoutHistoryTable({ rows }) {
  return (
    <>
      <div className="md:hidden">
        <PayoutHistoryList rows={rows} />
      </div>
      <div className="hidden overflow-x-auto md:block">
        <Table size="small">
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "#F8F8F8",
                "& th": {
                  border: "none",
                  py: 2,
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.06em",
                  color: "#9CA3AF",
                },
              }}
            >
              {HEAD.map((col) => (
                <TableCell key={col.id} align={col.align ?? "left"}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} sx={{ border: "none", py: 8 }}>
                  <p className="my-0 text-center text-[14px] font-medium text-[#9CA3AF]">
                    No payouts match your search.
                  </p>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "& td": {
                      borderColor: "#F0F0F0",
                      py: 2,
                      fontSize: "13px",
                    },
                  }}
                >
                  <TableCell className="font-medium text-[#4B5563]">
                    {row.dateLabel}
                  </TableCell>
                  <TableCell className="font-semibold text-[#1F2937]">
                    {row.reference}
                  </TableCell>
                  <TableCell align="right" className="font-semibold tabular-nums">
                    {formatWalletAmount(row.amountCents)}
                  </TableCell>
                  <TableCell className="max-w-[240px] truncate text-[#6B7280]">
                    {row.methodLabel}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </>
  );
}
